import { render, staticRenderFns } from "./SettingAlter.vue?vue&type=template&id=18a89937&"
import script from "./SettingAlter.vue?vue&type=script&lang=js&"
export * from "./SettingAlter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports